// extracted by mini-css-extract-plugin
module.exports = {"Label":"RuleCondition_Label__2MEgO"};